// import node module classes
import { useState, useEffect } from "react"

//GeoLocate
import { useGeolocated } from "react-geolocated";
import { getDistance } from "geolib"; // Import getDistance from geolib

import { LuUserPlus } from "react-icons/lu";
//bootstrap
import Nav from 'react-bootstrap/Nav'
import { Modal, Button, Spinner, InputGroup, Form } from "react-bootstrap"
import Navbar from 'react-bootstrap/Navbar'
import Container from 'react-bootstrap/Container'

//Components
import Address from "./components/Address"
import Calendar from "./components/Calendar"
import Login from "./entry/Login"
import SignUp from "./entry/SignUp"
import Admin from "./help/admin"
import About from "./help/about"
//import UpdateProfile from "./forms/UpdateProfile";
import XMembers, { UpdateProfile } from './components/XMembers';
import ClubAccess from "./components/ClubAccess";
import XDocz from './components/XDocz';
import XLinkz from "./components/xLinkz";
import XVideoz from './components/XVideoz';
import XArtist from "./components/XArtist";
import EventSuite from './components/EventSuite';
import './components/XDocList';

//toast
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import "typeface-quicksand"

// import firebase
import {
  getFirestore, collection, getDocs, doc, setDoc, query, where,
  addDoc,
  updateDoc,
  limit,
  orderBy,
  Timestamp
} from 'firebase/firestore'
import { auth, messaging } from "./utils/firebase"
import { signOut } from "firebase/auth"
import { onAuthStateChanged } from "firebase/auth";
import { getToken, onMessage } from "firebase/messaging";

// import images

import check from "./images/check.png"
import thumb from "./images/thumb.png"
import thumb2 from "./images/thumb2.png"
import { FaArrowUp } from 'react-icons/fa';
import expFail from './images/expFail.png'
import sun from "./images/sun.png"
import moon from "./images/moon.png"
// import custom classes and functions
import { spinner, checkEmpty } from "./utils/Helper"

export default function MainBody(props) {
  const [xState, setXState] = useState(0);
  const [show, setShow] = useState(false);
  const [showRegister, setShowRegister] = useState(false);;
  const [user, setUser] = useState('');
  const [userProfile, setUserProfile] = useState(false);
  const [userDisp, setUserDisp] = useState('');
  const [profileItems, setProfileItems] = useState([]);
  const hide = true
  const [isVisible, setIsVisible] = useState(true);
  const [theme, setTheme] = useState(localStorage.getItem('app-theme') || 'dark');
  const [BGCal, setBGCal] = useState(theme === 'dark' ? 'blacx' : 'lightx');
  const [BGHeader, setBGHeader] = useState(theme === 'dark' ? 'navDark' : 'navLight');
  const [isAdmin, setIsAdmin] = useState(false);

  // 2. Persist the theme whenever it changes
  useEffect(() => {
    localStorage.setItem('app-theme', theme);
    setBGCal(theme === 'dark' ? 'blacx' : 'lightx');
    setBGHeader(theme === 'dark' ? 'navDark' : 'navLight');


    // Optional: Apply a class to the body for global CSS targeting
    document.body.className = theme + '-theme';
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));

  };

  const db = getFirestore();
  //log Access 
  // --- States ---
  const [accessItems, setAccessItems] = useState([]);
  const [guestItems, setGuestItems] = useState([]);
  const [showGuestModal, setShowGuestModal] = useState(false);
  const [newGuestName, setNewGuestName] = useState("");
  const [isAddingGuest, setIsAddingGuest] = useState(false);
  const [distanceToClub, setDistanceToClub] = useState(0);


  // --- 1. Helper: Fetch Active Guests ---
  const fetchGuests = async (memberEmail) => {
    const logsRef = collection(db, "license_logs");
    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);

    const q = query(
      logsRef,
      where("signedInBy", "==", memberEmail.toLowerCase()),
      where("entryType", "==", "Guest"),
      where("scannedAt", ">=", Timestamp.fromDate(startOfToday)),
      orderBy("scannedAt", "desc")
    );

    const querySnapshot = await getDocs(q);
    // Soft-delete filter: Only show guests who are NOT cancelled
    return querySnapshot.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .filter(guest => guest.status !== "cancelled");
  };

  // --- 2. Main: Load Member Status & Guest Count ---
  const getAccessDoc = async (identifier) => {
    const logsRef = collection(db, "license_logs");
    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);

    try {
      spinner(true); // Your global app spinner
      const qMember = query(
        logsRef,
        where("rawPayload", "==", identifier.toLowerCase()),
        where("scannedAt", ">=", Timestamp.fromDate(startOfToday)),
        orderBy("scannedAt", "desc"),
        limit(1)
      );
      const snapMember = await getDocs(qMember);

      if (!snapMember.empty) {
        const docData = snapMember.docs[0].data();
        const activeGuests = await fetchGuests(identifier);

        setAccessItems([{
          id: snapMember.docs[0].id,
          ...docData,
          guestCount: activeGuests.length
        }]);
      } else {
        setAccessItems([]);
      }
    } catch (e) {
      console.error("Query Error:", e);
    } finally {
      spinner(false);
    }
  };

  // --- 3. Action: Show Guest Modal ---
  const handleShowGuests = async (memberEmail) => {
    if (!memberEmail) return;
    spinner(true);
    try {
      const guests = await fetchGuests(memberEmail);
      setGuestItems(guests);
      setShowGuestModal(true);
    } catch (e) {
      console.error(e);
      toast.error("Failed to load guests");
    } finally {
      spinner(false);
    }
  };

  // --- 4. Action: Add Guest ---
  const handleAddGuest = async (memberEmail) => {
    if (!newGuestName.trim()) return toast.warning("Enter a name");
    setIsAddingGuest(true);
    try {
      await addDoc(collection(db, "license_logs"), {
        fullName: newGuestName.trim(),
        entryType: "Guest",
        method: "Self Check in",
        signedInBy: memberEmail.toLowerCase(),
        rawPayload: memberEmail.toLowerCase(),
        scannedAt: Timestamp.now(),
        status: "active",
        isExpired: false
      });
      setNewGuestName("");
      const updated = await fetchGuests(memberEmail);
      setGuestItems(updated);

      // Update main button count badge
      setAccessItems(prev => prev.map(item =>
        item.rawPayload === memberEmail ? { ...item, guestCount: updated.length } : item
      ));
      toast.success("Guest added");
    } catch (e) {
      toast.error("Error adding guest");
    } finally {
      setIsAddingGuest(false);
    }
  };

  // --- 5. Action: Cancel Guest (Soft Delete) ---
  const handleCancelGuest = async (guestId, memberEmail) => {
    if (!window.confirm("Cancel this guest check-in?")) return;
    spinner(true);
    try {
      await updateDoc(doc(db, "license_logs", guestId), {
        status: "cancelled",
        cancelledAt: Timestamp.now()
      });
      const updated = await fetchGuests(memberEmail);
      setGuestItems(updated);

      // Update main button count badge
      setAccessItems(prev => prev.map(item =>
        item.rawPayload === memberEmail ? { ...item, guestCount: updated.length } : item
      ));
      toast.info("Guest cancelled");
    } finally {
      spinner(false);
    }
  };

  //end accesslogs

  const formatDisplayValue = (str) => {
    if (!str) return "";
    if (str.includes('@')) return str.toLowerCase();
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth animation
    });
  }

  //Start

  async function requestPermission() {
    //requesting permission using Notification API
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_VAPID_KEY
      });
      //We can send token to server
      console.log("Token generated : ", token);
    } else if (permission === "denied") {
      //notifications are blocked
      alert("You denied for the notification");
    }
  }


  useEffect(() => {




    onAuthStateChanged(auth, (user) => {
      if (user) {
        localStorage.setItem("email", user.email);
        localStorage.setItem("isAnon", user.isAnonymous);
        setUser(user.isAnonymous);
        setUserDisp(user.email);
        getProfileDoc();
      } else {
        localStorage.setItem("email", "Login");
        localStorage.setItem("isAnon", true);
        localStorage.setItem("user", "");
        localStorage.setItem("exp", "");
        localStorage.setItem("access", "");
        localStorage.setItem("isAdmin", false); // Reset admin on logout
        setUser(true);
        setUserDisp("login");
        setIsAdmin(false); // Update state
      }

      const email = localStorage.getItem('email');
      if (email && email !== "Login") {
        getAccessDoc(email);
      }
    });


    //requestPermission()

    onMessage(messaging, (payload) => {
      console.log('Message received in foreground: ', payload);
      // You can handle the message here, e.g., show a toast notification
      toast.info(payload.notification.title, { autoClose: false, });
    });

  }, [xState])



  const LocationDistanceCalculator = ({
    setDistanceToClub,
    accessItems,
    userProfile,
    handleChildAccessClub
  }) => {


    const email = localStorage.getItem('email');
    const isUserLoggedIn = email && email !== "Login";

    // --- TESTING TOGGLE ---
    const USE_MY_LOCATION = true;

    // Albuquerque default test coords (Replace these with your actual Lat/Long)
    const myCurrentTestCoords = {
      latitude: 30.2252032,
      longitude: -84.2399744,
    };

    const pressClubCoords = {
      latitude: 35.081747,
      longitude: -106.639145,
    };

    const targetLocation = USE_MY_LOCATION ? myCurrentTestCoords : pressClubCoords;

    const { coords, isGeolocationAvailable } = useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
        maximumAge: 60000,
        timeout: Infinity,
      },
      userDecisionTimeout: 5000,
      watchPosition: true,
      suppressLocationOnMount: false,
    });

    const distance = coords
      ? getDistance(
        { latitude: coords.latitude, longitude: coords.longitude },
        targetLocation
      )
      : null;

    // SAFE UPDATE + DEBUG LOGGING
    useEffect(() => {
      if (distance !== null && typeof setDistanceToClub === 'function' && isUserLoggedIn) {
        setDistanceToClub(distance);
      }
    }, [distance, setDistanceToClub]);

    useEffect(() => {
      if (!isGeolocationAvailable) {
        toast.error("Your browser does not support Geolocation");
      }
    }, [isGeolocationAvailable]);

    if (!coords) return null;


    const hasNotCheckedInToday = accessItems?.length === 0;
    const isWithinRange = distance <= 2000;

    return (
      <div className="check-in-section">
        {USE_MY_LOCATION && (
          <div style={{
            color: '#ff8c00',
            fontSize: '10px',
            textAlign: 'center',
            marginBottom: '5px',
            fontWeight: 'bold'
          }}>
            ⚠️ TEST MODE
          </div>
        )}

        {isWithinRange && isUserLoggedIn && hasNotCheckedInToday ? (
          <ClubAccess
            onSendToParent={handleChildAccessClub}
            memberName={userProfile?.name || email}
            memberEmail={email}
          />
        ) : null}
      </div>
    );

  };


  const getProfileDoc = async () => {
    spinner(true);
    const db = getFirestore();
    const ref = collection(db, "profiles");

    try {
      const q = query(ref, where('email', "==", localStorage.getItem('email')));
      const querySnapshot = await getDocs(q);
      const accessProfile = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setProfileItems(accessProfile);

      if (accessProfile.length > 0 && !checkEmpty(accessProfile[0].email)) {
        setUserProfile(true);
        localStorage.setItem("user", accessProfile[0].name);
        localStorage.setItem("exp", accessProfile[0].exp);

        // NEW: Admin role storage
        const adminStatus = accessProfile[0].isAdmin || false;
        localStorage.setItem("isAdmin", adminStatus);
        setIsAdmin(adminStatus); // Assuming setIsAdmin state exists in this file
      }
      spinner(false);
    } catch (error) {
      console.error("An error occurred in the event handler:", error);
      setUserProfile(false);
      setIsAdmin(false);
      localStorage.setItem("isAdmin", false);
    }
  };



  const handleLogout = () => {
    signOut(auth).then(() => {
      setUserProfile(false)
      spinner(true)
      // localStorage.setItem("isAnon", false)
      // localStorage.setItem("email", "Login")
      spinner(false)
      setXState(xState + 1);
    }).catch((error) => {
      // An error happened.
    });
  }

  const handleChildLogin = (data) => {
    if (data === "Register") {
      setShowRegister(true)
      setShow(false)
    } else {
      setShow(false)
      setXState(xState + 1);
    }
  };

  const handleChildProfileUpdate = () => {
    spinner(true)
    setXState(xState + 1);
    spinner(false)

  }

  const handleChildAccessClub = () => {
    spinner(true)
    setXState(xState + 1);
    spinner(false)

  }

  const handleChildRegister = (data) => {

    if (data === "UserX") {
      setShow(true)
      setShowRegister(false)
    } else {
      setShowRegister(false)
      setShow(false)
      setXState(xState + 1);
      getProfileDoc()
    }

  };

  return (
    <div>
      <div id="spinIt"></div>
      <div>
        <Navbar bg={theme} variant={theme} expand="lg" className={BGHeader}


        >
          <Container fluid>
            <Navbar.Brand>
              <div className="apc padding animated rollIn modified-apc">APC
              </div>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className=" justify-content-left flex-grow-1 ">
              </Nav>

              <Nav>


                <div id="accessX">
                  {userProfile ?

                    <LocationDistanceCalculator
                      setDistanceToClub={setDistanceToClub}
                      accessItems={accessItems}
                      userProfile={userProfile}
                      handleChildAccessClub={handleChildAccessClub}
                    />
                    : ""}
                  {userProfile ?

                    Array.isArray(accessItems) && accessItems.map((x) => (
                      <div key={x.id} className="position-relative d-inline-block  hoverX">

                        {/* Guest Count Badge */}
                        {x.guestCount > 0 && (
                          <span className="badge rounded-pill bg-danger position-absolute"
                            style={{ top: '-10px', right: '0px', zIndex: 2, border: '2px solid white' }}>
                            {x.guestCount} {x.guestCount === 1 ? 'Guest' : 'Guests'}
                          </span>
                        )}

                        <button
                          className={`btn `}
                          onClick={() => handleShowGuests(x.rawPayload)}
                          style={{ borderRadius: '15px', position: 'relative' }}
                        >
                          {/* Swaps Image based on Expired Status */}
                          <img src={x.isExpired ? expFail : check} className="check" alt="status" />
                          <br />
                          <span className="" style={{ display: 'block', marginTop: '5px' }}>
                            {/* Shows "Expired" text or the Timestamp */}
                            {x.isExpired ? (
                              <span className="orange"> "Expired"</span>
                            ) : (
                              ""
                              /* x.scannedAt?.toDate().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })*/
                            )}
                          </span>
                          {!x.isExpired && (
                            <span >{x.scannedAt?.toDate().toLocaleDateString()}</span>
                          )}
                        </button>
                      </div>
                    ))

                    : ""}
                </div>

                {localStorage.getItem('email') == "Login" ?
                  <Button onClick={() => setShow(true)}>
                    <img
                      src={thumb}
                      alt="login icon"
                      className="thumb hoverX animated fadeInRight"
                    />  <br></br>
                    <span className="">Login</span>
                  </Button>
                  :
                  <div >
                    <Button onClick={handleLogout}>
                      <img
                        src={thumb2}
                        alt="logout icon"
                        className="thumb hoverX animated fadeInRight"
                      />  <br></br>
                      <span className=""> Logout</span>

                    </Button>
                    {profileItems.map(x => (

                      <UpdateProfile
                        isTriggerOnly={false} // New prop to hide the default button UI
                        idx={x.id}
                        theme={theme}
                        key="x.id" hide={hide}
                        name={x.name}
                        type={x.type}
                        filex={x.filex}
                        onSendToParent={handleChildProfileUpdate}
                        className=""></UpdateProfile>


                    ))}

                    {userProfile ?
                      <>&nbsp;&nbsp;
                        <XDocz public={true} theme={theme}></XDocz>

                      </>
                      : ""}

                    {isAdmin && userProfile ?
                      <Admin></Admin>
                      : ""}



                  </div>


                }
              </Nav>
              <Nav id="end" className="white justify-content-end flex-grow-1 pe-4 ">
                {theme === 'dark' ?
                  <Button onClick={toggleTheme}>
                    <img
                      src={sun}
                      alt="Change to light mode"
                      className="thumb hoverX animated fadeInRight"
                    /><br></br> Mode
                  </Button>
                  : <Button onClick={toggleTheme}>
                    <img
                      src={moon}
                      alt="Change to dark mode"
                      className="thumb hoverX animated fadeInRight"
                    /><br></br> Mode
                  </Button>
                }
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>


      <div className={theme === 'dark' ? "bg-dark" : ""} style={{ 'marginTop': '-20px' }}>
        <div id="idx"></div>

        <div className="main">
          <span className="padding"> <h1 className={theme === 'dark' ? "apc-text text-light animated fadeInLeft" : "apc-text text-dark animated fadeInLeft"}>The Albuquerque Press Club</h1>
            <span style={{ fontSize: '2.5vh' }}>
              promotes fellowship and understanding among people engaged in journalism and its allied fields, sponsors cultural, educational and social activities that promote good fellowship and
              professional growth among members, and extends reciprocity to similar clubs in other parts of the nation and world.
            </span>
          </span>
        </div>
        <About theme={theme}></About>
        <div className="p-2 mx-2">

          {/* Calling the Event Suite for Users */}
          <EventSuite
            theme={theme}
            currentUser={user}
            isAdmin={false} // Prevents admin emoji from showing
          />

        </div>

        <div >
          <div className={BGCal}>
            <div className="flex-container-main calx paddingXL centerIt">
              <Calendar></Calendar>
              <hr></hr>
            </div>
          </div>
        </div>

        <div className={` borderx ${theme === 'dark' ? 'bg-dark' : 'bg-light'}`} >  <XArtist></XArtist></div><br></br>

        <div className={` bordery padding ${theme === 'dark' ? 'bg-dark' : ''}`}  >
          <div className="container-fluid" >
            <div className="row g-3">
              <div className="col-12 col-lg-3">
                <XLinkz theme={theme} />
              </div>
              <div className="col-12 col-lg-3 m-0 ">
                <XVideoz></XVideoz>
              </div>
              <div className="col-12 col-lg-3">
                <h4 className="orange">
                  Rep your favorite house on the hill!</h4>
                <div className={`container-fluid ${theme === 'dark' ? 'glassBlack' : ''}`}>
                  <div style={{ 'fontSize': '1.2rem' }} className="text-muted padding">
                    We have zip hoodies, baseball shirts, two different t-shirt designs, mugs, lighters. <br></br>Also we have gift cards on top of gifting a membership to a friend – just ask your bartender.
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-3 px-4 py-1 rounded clubx" style={{ 'minHeight': '250px' }}>
              </div>
            </div>
          </div>
        </div>

      </div>
      <>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          dialogClassName="md-down"
          backdropClassName="adminBackdrop"
          contentClassName="bg-dark"
          aria-labelledby="LogIn screen"
        >

          <Modal.Body>
            <Login onSendToParent={handleChildLogin}></Login>
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="outline-warning" onClick={() => setShow(false)} className="px-4">
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>

      <>
        <Modal
          show={showRegister}
          onHide={() => setShowRegister(false)}
          dialogClassName="md-down"
          aria-labelledby="Register screen"
          backdropClassName="adminBackdrop"
          contentClassName="bg-dark"

        >
          <Modal.Body>
            <SignUp onSendToParent={handleChildRegister}></SignUp>
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="outline-warning" onClick={() => setShowRegister(false)} className="px-4">
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>


      <Modal
        show={showGuestModal}
        onHide={() => setShowGuestModal(false)}
        centered

        contentClassName="qr-modal-content"
      >
        {/* The colored bar at the top to match the scanner result style */}
        <div className="qr-modal-success-bar" style={{ background: 'var(--brand-primary)' }}></div>

        <Modal.Body className="p-0 glass-modal-content">
          <div className="qr-modal-body-container">
            {/* Header Section */}
            <div className="mb-4 text-center">
              <div className="mb-2" style={{ fontSize: '2.5rem', color: 'var(--brand-primary)' }}>
                <LuUserPlus />
              </div>
              <h2 className="fw-bold text-white mb-1">Guest Management</h2>
              <p className="qr-subtext">Sponsor: {formatDisplayValue(accessItems[0]?.fullName)}</p>
            </div>

            {/* Add Guest Input Section */}
            <div className="qr-guest-section mb-4">
              <label className="qr-label mb-2 text-start d-block">Add New Guest</label>
              <InputGroup className="mb-2">
                <Form.Control
                  placeholder="Enter Guest Name..."
                  className="qr-input"
                  value={newGuestName}
                  onChange={(e) => setNewGuestName(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleAddGuest(accessItems[0]?.rawPayload)}
                />
                <button
                  className="qr-btn qr-btn-primary"
                  style={{ borderRadius: '0 6px 6px 0' }}
                  onClick={() => handleAddGuest(accessItems[0]?.rawPayload)}
                  disabled={isAddingGuest}
                >
                  {isAddingGuest ? <Spinner size="sm" /> : "ADD"}
                </button>
              </InputGroup>
            </div>

            {/* Guest List Table */}
            <div className="qr-table-container text-start" style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <table className="qr-table">
                <thead>
                  <tr>
                    <th className="ps-3">GUEST NAME</th>
                    <th className="text-end pe-3">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {guestItems.length > 0 ? (
                    guestItems.map((guest) => (
                      <tr key={guest.id}>
                        <td className="ps-3 py-3 fw-bold text-white">
                          {formatDisplayValue(guest.fullName)}
                        </td>
                        <td className="text-end pe-3">
                          <button
                            className="btn btn-sm btn-outline-danger border-0"
                            onClick={() => handleCancelGuest(guest.id, accessItems[0]?.rawPayload)}
                            title="Cancel Guest"
                          >
                            REMOVE
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="text-center py-4 qr-subtext">
                        No active guests for this session.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Footer Action */}
            <div className="mt-4">
              <button
                className="qr-btn qr-btn-warning w-100"
                onClick={() => setShowGuestModal(false)}
              >
                CLOSE
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>



      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {isVisible && (
        <div className="scroll-to-top-arrow" onClick={scrollToTop}>
          <FaArrowUp style={{ display: isVisible ? 'block' : 'none' }} />
        </div>)}

      <footer className="blacx">
        <Address distance={distanceToClub} /><br></br>
      </footer>
    </div >

  );
}
